import styledComp from 'styled-components';
import styled from '@mui/styles/styled';
import { DialogActions } from '@mui/material';
import ReactSelect from 'react-select';

import { Styling, Colors } from '../../../constants';

export const DialogHeader = styledComp.div`
  display: flex;
  align-items: center;

  padding: ${Styling.DEFAULT_SPACING}px;
  background-color: #f7f7f7;
  height: 78px;
`;

export const DialogHeaderTitle = styledComp.div`
  overflow: hidden;
  align-items: center;
  font-weight: bold;
  font-size: 20px;
  display: flex;
  width: 100%;
  padding-bottom: 2px;
`;

export const DialogHeaderDuration = styledComp.span`
  margin-left: auto;
`;

export const DialogContentContainer = styledComp.div`
  font-size: 14px;
  padding: ${Styling.DEFAULT_SPACING}px;
`;

export const DialogActionsOverride = styled(DialogActions)({

});

export const ActionContainer = styledComp.div`
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    margin-left: ${Styling.DEFAULT_SPACING}px;
  }
`;

export const ControlContainer = styledComp.div`
  &:not(:last-child) {
    margin-bottom: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  }`;

export const ControlLabel = styledComp.div`
  font-weight: bold;
  margin-bottom: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const Selectable = styledComp(ReactSelect)`
  &.css-1pcexqc-container {
    &.css-bg1rzq-control {
      border-color: ${Colors.PAPER_BORDER} !important;
    }
  }
`;
